import clsx from 'clsx'
import { useEffect, useRef } from 'react'

const formClasses =
  'block w-full appearance-none rounded-lg border border-gray-500 bg-gray-800 py-[calc(theme(spacing.2)-1px)] px-[calc(theme(spacing.3)-1px)] text-white placeholder:text-gray-400 focus:border-cyan-500 focus:outline-none focus:ring-cyan-500 sm:text-sm'
type LabelProps = {
  id: string
  children: React.ReactNode
  className?: string
}
export function Label({ id, children, className = '' }: LabelProps) {
  return (
    <label
      htmlFor={id}
      className={clsx('mb-2 block text-sm font-semibold text-white', className)}
    >
      {children}
    </label>
  )
}

type TextFieldProps = {
  id: string
  label?: string
  autoFocus?: boolean
  type?: string
  setValue: (value: string) => void
  value: string
  className?: string
  errorMessage?: string
  placeholder?: string
} & React.ComponentProps<'input'>
export function TextField({
  id,
  label,
  autoFocus = false,
  type = 'text',
  setValue = () => null,
  value,
  className,
  errorMessage = '',
  placeholder = '',
  ...props
}: TextFieldProps) {
  const inputElement = useRef<HTMLInputElement>(null)
  useEffect(() => {
    if (inputElement.current && autoFocus) {
      inputElement.current.focus()
    }
  }, [])
  return (
    <div className={className}>
      {label && <Label id={id}>{label}</Label>}
      <input
        ref={inputElement}
        id={id}
        type={type}
        value={value}
        placeholder={placeholder}
        {...props}
        onChange={(e) => setValue(e.target.value)}
        className={formClasses}
      />
      {errorMessage && (
        <p className="mt-1 text-xs text-red-500">{errorMessage}</p>
      )}
    </div>
  )
}

type SelectFieldProps = {
  id: string
  label?: string
  className?: string
  value: string
  setValue: (value: string) => void
} & React.ComponentProps<'select'>
export function SelectField({
  id,
  label,
  className,
  value,
  setValue,
  ...props
}: SelectFieldProps) {
  return (
    <div className={className}>
      {label && <Label id={id}>{label}</Label>}
      <select
        id={id}
        {...props}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={clsx(formClasses, 'pr-8')}
      />
    </div>
  )
}
